/**
 * The band shown under the header while the backend cannot be reached, without discarding what
 * the page already shows: the last state it loaded stays readable, and every page says on its own
 * when that state is old (load-state.js). Listens for itself; the shell only places it.
 */
import { LitElement, html } from 'lit';

import { CONNECTIVITY_CHANGED_EVENT, connectivity } from '../../lib/connectivity/index.js';
import { planeConnectionBarStyles } from '../../styles/components/plane-connection-bar.js';

class PlaneConnectionBar extends LitElement {
  static properties = {
    online: { state: true },
  };

  static styles = planeConnectionBarStyles;

  constructor() {
    super();
    this.online = connectivity.isOnline();
    this.onChanged = (event) => {
      this.online = event.detail.online;
    };
  }

  connectedCallback() {
    super.connectedCallback();
    document.body.addEventListener(CONNECTIVITY_CHANGED_EVENT, this.onChanged);
  }

  disconnectedCallback() {
    document.body.removeEventListener(CONNECTIVITY_CHANGED_EVENT, this.onChanged);
    super.disconnectedCallback();
  }

  render() {
    // hidden while online, the common case: no empty band above the page
    this.hidden = this.online;
    if (this.online) {
      return null;
    }
    return html`<div class="bar" role="status">You are offline: plane will reconnect on its own. What you see may be old.</div>`;
  }
}

customElements.define('plane-connection-bar', PlaneConnectionBar);
